function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/setheaderrowcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { createEmptyTableCell, updateNumericAttribute } from './utils';
import { getSelectionAffectedTableCells } from '../utils';
import TableWalker from '../tablewalker';
/**
 * The header row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableColumnHeader'` editor command.
 *
 * You can make the row containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element) by executing:
 *
 *		editor.execute( 'setTableRowHeader' );
 *
 * **Note:** All preceding rows will also become headers. If the current row is already a header, executing this command
 * will make it a regular row back again (including the following rows).
 *
 * @extends module:core/command~Command
 */

var SetHeaderRowCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(SetHeaderRowCommand, _Command);

  function SetHeaderRowCommand() {
    _classCallCheck(this, SetHeaderRowCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(SetHeaderRowCommand).apply(this, arguments));
  }

  _createClass(SetHeaderRowCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var _this = this;

      var model = this.editor.model;
      var selectedCells = getSelectionAffectedTableCells(model.document.selection);
      var isInTable = selectedCells.length > 0;
      this.isEnabled = isInTable;
      /**
       * Flag indicating whether the command is active. The command is active when the
       * {@link module:engine/model/selection~Selection} is in a header row.
       *
       * @observable
       * @readonly
       * @member {Boolean} #value
       */

      this.value = isInTable && selectedCells.every(function (cell) {
        return _this._isInHeading(cell, cell.parent.parent);
      });
    }
    /**
     * Executes the command.
     *
     * When the selection is in a non-header row, the command will set the `headingRows` table attribute to cover that row.
     *
     * When the selection is already in a header row, it will set `headingRows` so the heading section will end before that row.
     *
     * @fires execute
     * @param {Object} options
     * @param {Boolean} [options.forceValue] If set, the command will set (`true`) or unset (`false`) the header rows according to
     * the `forceValue` parameter instead of the current model state.
     */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var selectedCells = getSelectionAffectedTableCells(model.document.selection);
      var firstCell = selectedCells[0];
      var lastCell = selectedCells[selectedCells.length - 1];
      var table = firstCell.parent.parent;
      var currentHeadingRows = table.getAttribute('headingRows') || 0;

      var _sort = // Returned cells might not necessary be in order, so make sure to sort it.
      [firstCell.parent.index, lastCell.parent.index].sort(),
          _sort2 = _slicedToArray(_sort, 2),
          selectedRowMin = _sort2[0],
          selectedRowMax = _sort2[1];

      if (options.forceValue === this.value) {
        return;
      }

      var headingRowsToSet = this.value ? selectedRowMin : selectedRowMax + 1;
      model.change(function (writer) {
        if (headingRowsToSet) {
          // Changing heading rows requires to check if any of a heading cell is overlapping vertically the table head.
          // Any table cell that has a rowspan attribute > 1 will not exceed the table head so we need to fix it in rows below.
          var cellsToSplit = getOverlappingCells(table, headingRowsToSet, currentHeadingRows);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = cellsToSplit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var cell = _step.value;
              splitHorizontally(cell, headingRowsToSet, writer);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        updateNumericAttribute('headingRows', headingRowsToSet, table, writer, 0);
      });
    }
    /**
     * Checks if a table cell is in the heading section.
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {module:engine/model/element~Element} table
     * @returns {Boolean}
     * @private
     */

  }, {
    key: "_isInHeading",
    value: function _isInHeading(tableCell, table) {
      var headingRows = parseInt(table.getAttribute('headingRows') || 0);
      return !!headingRows && tableCell.parent.index < headingRows;
    }
  }]);

  return SetHeaderRowCommand;
}(Command); // Returns cells that span beyond the new heading section.
//
// @param {module:engine/model/element~Element} table The table to check.
// @param {Number} headingRowsToSet New heading rows attribute.
// @param {Number} currentHeadingRows Current heading rows attribute.
// @returns {Array.<module:engine/model/element~Element>}


export { SetHeaderRowCommand as default };

function getOverlappingCells(table, headingRowsToSet, currentHeadingRows) {
  var cellsToSplit = [];
  var startAnalysisRow = headingRowsToSet > currentHeadingRows ? currentHeadingRows : 0; // We're analyzing only when headingRowsToSet > 0.

  var endAnalysisRow = headingRowsToSet - 1;
  var tableWalker = new TableWalker(table, {
    startRow: startAnalysisRow,
    endRow: endAnalysisRow
  });
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = tableWalker[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _step2$value = _step2.value,
          row = _step2$value.row,
          rowspan = _step2$value.rowspan,
          cell = _step2$value.cell;

      if (rowspan > 1 && row + rowspan > headingRowsToSet) {
        cellsToSplit.push(cell);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return cellsToSplit;
} // Splits the table cell horizontally.
//
// @param {module:engine/model/element~Element} tableCell
// @param {Number} headingRows
// @param {module:engine/model/writer~Writer} writer


function splitHorizontally(tableCell, headingRows, writer) {
  var tableRow = tableCell.parent;
  var table = tableRow.parent;
  var rowIndex = tableRow.index;
  var rowspan = parseInt(tableCell.getAttribute('rowspan'));
  var newRowspan = headingRows - rowIndex;
  var attributes = {};
  var spanToSet = rowspan - newRowspan;

  if (spanToSet > 1) {
    attributes.rowspan = spanToSet;
  }

  var colspan = parseInt(tableCell.getAttribute('colspan') || 1);

  if (colspan > 1) {
    attributes.colspan = colspan;
  }

  var startRow = table.getChildIndex(tableRow);
  var endRow = startRow + newRowspan;

  var tableMap = _toConsumableArray(new TableWalker(table, {
    startRow: startRow,
    endRow: endRow,
    includeSpanned: true
  }));

  var columnIndex;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = tableMap[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _step3$value = _step3.value,
          row = _step3$value.row,
          column = _step3$value.column,
          cell = _step3$value.cell,
          cellIndex = _step3$value.cellIndex;

      if (cell === tableCell && columnIndex === undefined) {
        columnIndex = column;
      }

      if (columnIndex !== undefined && columnIndex === column && row === endRow) {
        var _tableRow = table.getChild(row);

        var tableCellPosition = writer.createPositionAt(_tableRow, cellIndex);
        createEmptyTableCell(writer, tableCellPosition, attributes);
      }
    } // Update the rowspan attribute after updating table.

  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  updateNumericAttribute('rowspan', newRowspan, tableCell, writer);
}